function initMultiColumnCustomSlider() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.multi-column-custom-swiper').forEach(function (swiperElement) {
    // Destroy existing swiper instance if any
    if (swiperElement.swiper) {
      swiperElement.swiper.destroy(true, true);
    }

    const block = swiperElement.closest('.multi-column-custom-block');
    if (!block) return;

    const desktopSlides = parseFloat(swiperElement.dataset.desktopSlides) || 3.2;
    const mobileSlides = parseFloat(swiperElement.dataset.mobileSlides) || 1.1;
    const spaceBetween = parseInt(swiperElement.dataset.spaceBetween, 10) || 24;
    const slidesCount = swiperElement.querySelectorAll('.swiper-slide').length;
    const controls = block.querySelector('.multi-column-custom-controls');

    const swiper = new Swiper(swiperElement, {
      slidesPerView: mobileSlides,
      spaceBetween: 16,
      navigation: {
        nextEl: block.querySelector('.swiper-button-next'),
        prevEl: block.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: block.querySelector('.swiper-scrollbar'),
        draggable: false,
        hide: false,
      },
      on: {
        progress: function (swiper, progress) {
          const progressEl = block.querySelector('.swiper-scrollbar-progress');
      
          if (!progressEl) return;
      
          const slidesPerView = swiper.params.slidesPerView;
          const slidesCount = swiper.slides.length;
      
          const visibleRatio = Math.min(
            slidesPerView / slidesCount,
            1
          );
      
          const width = visibleRatio + progress * (1 - visibleRatio);
      
          progressEl.style.width = `${width * 100}%`;
        },
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 16 },
        1024: { slidesPerView: desktopSlides, spaceBetween: spaceBetween },
      },
    });

    const updateControlsVisibility = () => {
      if (!controls) return;
      controls.style.display = slidesCount > swiper.params.slidesPerView ? '' : 'none';
    };

    swiper.on('init breakpoint resize', updateControlsVisibility);
    updateControlsVisibility();
  });
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', initMultiColumnCustomSlider);

// Reinitialize on Shopify theme editor events
document.addEventListener('shopify:section:load', initMultiColumnCustomSlider);
document.addEventListener('shopify:section:select', initMultiColumnCustomSlider);
document.addEventListener('shopify:section:reorder', initMultiColumnCustomSlider);

// Handle settings changes in theme editor
if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', initMultiColumnCustomSlider);
  document.addEventListener('shopify:block:deselect', initMultiColumnCustomSlider);
}
